import throttle from '../utils/throttle';

const TOOLTIP_SHIFT_LEFT = 'my-account__hero-tip--shift-left';
const TOOLTIP_MARGIN = 16;

function createTooltipMeasurer() {
  const measurer = document.createElement('div');
  measurer.className = 'my-account__hero-tip-measure';
  document.body.appendChild(measurer);
  return measurer;
}

export default function myAccountTooltip() {
  const tips = Array.from(document.querySelectorAll('.my-account__hero-tip'));
  if (!tips.length) {
    return;
  }

  const measurer = createTooltipMeasurer();

  const update = () => {
    const viewportWidth = window.innerWidth;

    tips.forEach((tip) => {
      const icon = tip.querySelector('.my-account__hero-icon');
      const text = tip.dataset.tip || '';
      if (!icon || !text) {
        tip.classList.remove(TOOLTIP_SHIFT_LEFT);
        return;
      }

      measurer.textContent = text;
      const tooltipWidth = measurer.getBoundingClientRect().width;
      const rect = icon.getBoundingClientRect();
      const iconCenter = rect.left + rect.width / 2;
      const rightOverflow = iconCenter + tooltipWidth / 2 > viewportWidth - TOOLTIP_MARGIN;

      if (rightOverflow) {
        tip.classList.add(TOOLTIP_SHIFT_LEFT);
      } else {
        tip.classList.remove(TOOLTIP_SHIFT_LEFT);
      }
    });
  };

  const throttledUpdate = throttle(update, 200);

  update();
  window.addEventListener('resize', throttledUpdate);
}
